import palette from '../palette';

export default {
  root: {
    '& .MuiInputLabel-outlined': {
      color: palette.text.secondary
    }
  }
};
